<template>
    <div></div>
</template>
<script>
export default {
    name: "SpFooter",
};
</script>



// WEBPACK FOOTER //
// src/views/layout/sp/Footer.vue